<style>
    #numeric {
        list-style-type: decimal;
        counter-reset: listNumbering;
        font-family: "Poppins";
    }

    #numeric>li::marker {
        font-size: 16px;
        font-family: "Poppins";
        font-weight: 600;
    }
</style>
<div class="khr-intro-section-wrap bg-dark text-center pt-5">
    <h1 class="text-white mb-0">Privacy Policy</h1>
    <p class="text-white opacity-75 fw-normal mb-5">
        Last updated as on 26.03.2025.
    </p>
</div>
<div class="row g-0 justify-content-center khr-overlay-card">
    <div class="col col-lg-7">
        <pmd-card class="p-4">
            <div class="text-start">
                <p class="mb-3">
                    This document is an electronic record in terms of the Information Technology Act, 2000 and rules
                    there under as applicable and the amended provisions pertaining to electronic records in various
                    statutes as amended by the Information Technology Act, 2000. This electronic record is generated by
                    a computer system and does not require any physical or digital signatures.
                </p>

                <p class="mb-3">
                    Prayosha Food Services Private Limited, a private limited company incorporated under the laws of
                    India
                    <b>“Company”, “we”, “us” or “our&quot;</b> ), manages and operates the
                    website
                    <a href="https://www.petpooja.com/purchase"
                        class="text-primary fw-bold">(https://www.petpooja.com/purchase)</a>
                    and domain name, and any other linked pages, features, content, mobile
                    applications <strong>(‘Purchase Scan’)</strong> , or any other services we
                    offer from time to time in connection therewith (collectively the
                    <strong>&quot;Platform&quot;</strong> ) which is an online platform
                    which enables Users to purchase the products and/or services offered
                    in the Platform.
                </p>

                <p class="mb-3">
                    All users of the website are advised to read and understand our Privacy Policy and Terms &
                    Conditions carefully before registering, accessing or using the website or any services offered by
                    the Company. By giving your consent for accessing the Platform (either as a visitor or a customer),
                    you (hereinafter referred to as <strong>“you”</strong>, <strong>“your”</strong>,
                    <strong>“user”</strong>, as applicable) expressly
                    consent to our
                    collection, storage, use and disclosure of the Information (as defined hereunder) in accordance with
                    the terms of this Privacy Policy, as amended from time to time. By consenting you agree to be bound
                    by the terms and conditions of this Policy, as they apply to you.

                </p>
                <p class="mb-3">
                    This Platform is published and maintained by the Company. This Privacy
                    Policy, as amended from time to time (“
                    <strong>Privacy Policy</strong> ”) is applicable to the websites of
                    the Company. This Privacy Policy along with the <a href="javascript: void(0);"
                        target="_blank"
                        routerLink="/terms"
                        class="text-primary fw-bold">terms and conditions</a> (
                    <strong>&quot;Terms &amp; Conditions”</strong> ) ggovern your use of the Platform based on the
                    information provided by you to us. This Privacy Policy does not apply to the websites of our
                    business partners, corporate affiliates or to any other third parties, even if their websites are
                    linked to the site. We recommend you review the respective privacy statements of the other parties
                    with whom you interact. If you do not agree with any of the terms contained in this Policy or the
                    Terms & Conditions, please do not use or access the Platform.

                </p>
                <p class="mb-3">
                    The capitalized terms which have been used herein but are not specifically defined shall have the
                    same meaning as attributed to such terms in the Terms & Conditions. In the event of any
                    inconsistency between the Terms & Conditions and this Privacy Policy, the Privacy Policy will
                    supersede solely in respect of the content contained herein and not in respect of any other clause,
                    term or provision contained in the Terms & Conditions.

                </p>
                <p class="mb-3">
                    This document is an electronic record in terms of applicable laws including the Indian Information
                    Technology Act, 2000, Indian Information Technology (Intermediary Guidelines) Rules, 2011 and any
                    other laws as may be applicable to the jurisdiction thereunder as applicable and the amended
                    provisions pertaining to electronic records in various statutes. This electronic record is generated
                    by a computer system and does not require any physical or digital signatures.

                <ol id="numeric">
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">How do I Sign Up?</h6>
                        <p>
                            You can register by clicking on the “Log in/Register/Sign up/ Sign in” link on the Platform.
                            Please provide the information in the form that appears. Please review the Terms &
                            Conditions before you sign up.

                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">Personal</h6>
                        <p>
                            The Company is the licensed owner of the brand <strong>‘Petpooja Purchase’</strong> and
                            ‘Purchase Scan’. This Privacy Policy provides succinctly the manner your data is collected
                            andused by the Company on the Platform. As a visitor to the Platform, you are advised to
                            please read the Privacy Policy carefully. By accessing the services provided by the Platform
                            youagree to the collection and use of your data by the Company in the manner provided in
                            this Privacy Policy.
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">
                            What information is, or maybe, collected from you?
                        </h6>
                        <p>
                            As part of the registration process on the Platform, the Company may collect the following
                            information (<strong>“Information”</strong>):

                        </p>
                        <ol type="a">
                            <li class="mb-3">
                                <a href="#"
                                    class="text-decoration-underline">Personal Information:</a>
                                Personally identifiable information shall include all information that can be linked to
                                a specific individual or to identify any individual, such as the following
                                (“<strong>Personal
                                    Information</strong>”):

                                <ul class="mb-4">
                                    <li class="mb-3">
                                        Registration information: Name (including name of the entity and/or its
                                        representative), alternate email id, mobile number and contact
                                        details, postal code, demographic profile (like your age, gender, occupation,
                                        address etc.), educational qualifications, business category, volume of
                                        transaction, financial information such as bank account, payment card numbers,
                                        card expiry date, credit reports.

                                    </li>
                                    <li class="mb-3">
                                        Information from third party: Identity of your card issuer or financial
                                        institution, information regarding access to balances held in your bank account
                                        linked with the platform, amount of loan granted and to be repaid.

                                    </li>
                                    <li class="mb-3">
                                        Transaction information: Invoice number, Day, date, time, amount, name, email
                                        address and location of the payment receiver, type of payment method used.

                                    </li>
                                    <li class="mb-3">
                                        Any Personal Information provided by you will not be considered as sensitive if
                                        it is freely available and/or accessible in public domain.
                                    </li>
                                </ul>
                                <p class="mb-3">
                                    Please note that the above list is not an exhaustive list and is only an
                                    illustrative list and is <strong>without</strong> prejudice to our right to seek
                                    further Personal
                                    Information, as may be required for the provision of the services to you.

                                </p>
                                <p class="mb-3">


                                    We will be entitled to remove any content uploaded by you on the Platform which we,
                                    in our sole discretion consider offensive, discriminatory, racist, defamatory, or
                                    inappropriate in nature.

                                </p>
                                <p class="mb-3">
                                    <b> Note:</b> Any content on the Platform shared by you or end users via reviews,
                                    blogs, online chat or instant messages, discussion boards, forums, user testimonials
                                    etc. are not considered as Personal Information and is not subject to the terms of
                                    this Privacy Policy. We will not be responsible for the accuracy or filtration of
                                    any of the content uploaded on our Platform by you.

                                </p>
                                <p>
                                    When browsing our Platform, you are not required to provide any Personal Information
                                    unless and until you choose to avail any services available on the Platform.

                                </p>
                            </li>
                            <li class="mb-4">
                                <a href="#"
                                    class="text-decoration-underline">Non-Personal Information:</a>
                                When you visit the Platform, we may collect certain non-personal information such as
                                your internet protocol address, operating system, browser type, internet service
                                provider, information about the pages on the Platform you visit/access, the links you
                                click on the Platform, the number of times you access the page and any such browsing
                                information. This type of information does not identify you personally. We may also
                                collect information about the services that you use and how you use them, including
                                log-in information and location information, when you are a user of the services through
                                the Platform.
                            </li>
                            <li class="mb-4">
                                <a href="#"
                                    class="text-decoration-underline">Automatic Information:</a>
                                To improve the responsiveness of the Platform for you, we automatically collect certain
                                information when you visit, use or navigate through the Platform. We may use online
                                identifiers like <i>"cookies"</i>, and/or similar electronic tools to collect
                                information to
                                understand your individual interests for analytics and marketing. These server logs may
                                include information such as your web request, internet protocol address, browser type,
                                browser language, the date and time of your request and one or more cookies that may
                                uniquely identify your browser. We use cookies primarily for user authentication but may
                                also use them to improve the quality of our service by storing user preferences and
                                tracking user trends.

                            </li>
                            <li class="mb-4">
                                <a href="#"
                                    class="text-decoration-underline">Mobile phone:</a>
                                When you use the Platform through your mobile, we may receive information about your
                                location and your mobile device, including a unique identifier number for your device.
                                We may use this information to provide you with suggestions in respect of services if
                                required. We may automatically collect device information (such as your mobile device
                                ID, model, and manufacturer), operating system, version information, and IP address.
                            </li>
                            <li class="mb-4">
                                <a href="#"
                                    class="text-decoration-underline">User communications:</a>
                                When you send emails or other communications to us, we may retain those communications
                                to process your inquiries, respond to your requests and improve our services provided
                                through the Platform.
                            </li>
                            <li class="mb-4">
                                <a href="#"
                                    class="text-decoration-underline">Information on behalf of minor children:</a>
                                The Platform and its contents are not targeted to minors (those under the age of 18).
                                However, the Company have no way of distinguishing the age of individuals who access our
                                Platform. Any information that you provide, as the legal guardian of the minor child,
                                while using the Platform or service on behalf of your minor child will be treated as
                                Personal Information unless otherwise provided herein. If you have reason to believe
                                that a minor child has provided Personal Information to us through the usage of our
                                Platform, please contact our Grievance Redressal Officer <i>(at the details provided
                                    below)</i>
                                and we will endeavor to delete that information and terminate the minor's account from
                                our databases.
                            </li>
                            <li class="mb-4">
                                <a href="#"
                                    class="text-decoration-underline">Push Notifications:</a>
                                We may request to send you push notifications regarding your account or the mobile
                                application. If you wish to opt-out from receiving these types of communications, you
                                may turn it off in your device's settings.
                            </li>
                        </ol>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">How do we Collect the Information?</h6>
                        <p>
                            The Company will collect personally identifiable information about you as part of a
                            voluntary registration process, transaction process or financial information linked to the
                            bank account from third part thereof. The Platform may contain links to other websites. The
                            Company is not responsible for the privacy practices of such websites which it does not own,
                            manage or control. The Platform and third-party vendors, including Google, use first-party
                            cookies (such as the Google Analytics cookie) and third-party cookies together to inform,
                            optimize, and serve ads based on someone’s past visits to the Platform.
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">How is information used?</h6>
                        <p>
                            The Company will process the Information you provide with security, integrity and
                            confidentiality in any one or more of the following manners, in accordance with this Privacy
                            Policy and as permitted by applicable laws:
                        </p>
                        <ol type="a">
                            <li class="mb-3">
                                fair use of your personal information to provide personalized features to you on the
                                Platform and to provide promotional offers to you through the Platform and other
                                channels.
                            </li>
                            <li class="mb-3">
                                provide your personal information to its business associates and partners to get in
                                touch with you when necessary to provide the services.

                            </li>
                            <li class="mb-3">
                                use this information to preserve transaction history as governed by applicable law or
                                policy.
                            </li>
                            <li class="mb-3">
                                may also use contact information internally to direct its efforts for product
                                improvement, to contact you as a survey respondent; and to send you promotional
                                materials from its advertisers.
                            </li>
                            <li class="mb-3">
                                will also use this information to provide services requested by you.

                            </li>
                            <li class="mb-3">
                                used to provide various promotional and advertising materials to you via display
                                advertisements through third party websites. You can opt out of display advertising and
                                customize. Information about suppliers on an aggregate (excluding any information that
                                may identify you specifically) covering supplier transaction data and supplier
                                demographic and location data may be provided to partners of the Company for the purpose
                                of creating additional features on the Platform, creating appropriate merchandising or
                                creating new products and services and conducting marketing research and statistical
                                analysis of customer behavior and transactions.

                            </li>
                            <li class="mb-3">To improve our services.</li>
                            <li class="mb-3">To enforce our Terms &amp; Conditions.</li>
                            <li class="mb-3">
                                To protect the security or integrity of the Platform, our
                                business, services and users.
                            </li>
                            <li class="mb-3">
                                Preventing, detecting, investigating, and taking action against
                                crimes (including but not limited to fraud and other financial
                                crimes), any other illegal activities, suspected fraud, or
                                violations of Terms &amp; Conditions in any jurisdiction.
                            </li>
                            <li class="mb-3">
                                To the extent required for identity verification, government
                                sanctions screening and due diligence checks.
                            </li>
                            <li class="mb-3">
                                To publish any testimonials or reviews that you may have
                                provided on the Platform.
                            </li>
                            <li class="mb-3">
                                Conducting surveys, collecting feedback about our services and
                                contact you about your use of our Platform.
                            </li>
                        </ol>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">
                            With whom your information will be shared?
                        </h6>
                        <p>
                            The Company will not use your financial information for any purpose other than to complete a
                            transaction with you. It does not rent, sell or share your personal information and will not
                            disclose any of your personally identifiable information to third parties, save and expect
                            in furtherance to provision of services. In cases where it has your permission to provide
                            products or services you’ve requested, and such information is necessary to provide these
                            products or services the information may be shared with the Company’s business associates
                            and partners.
                        </p>
                        <p>
                            The Company may, however, share transaction information on an aggregate with its partners or
                            third parties where it deems necessary to provide services and for maintenance of account.
                            In addition, the Company may use this information for promotional offers, to help
                            investigate, prevent or take action regarding unlawful and illegal activities, suspected
                            fraud, potential threat to the safety or security of any person, violations of the
                            Platform’s terms of use or to defend against legal claims; special circumstances such as
                            compliance with subpoenas, court orders, requests/order from legal authorities or law
                            enforcement agencies requiring such disclosure.

                        </p>
                        <p>
                            We also provide certain data to our business partners, such as payment gateways, legal and
                            administrative consultants, financial institutions/banks that offer financial aid to users
                            of the Platform, etc., to interact with you and/or send you relevant or required
                            information, as well as to complete certain transactions and fulfill commitments. After your
                            data is made accessible to the business partners mentioned above, such business partners may
                            use your data to send you information relevant to you. We are not, in any manner whatsoever,
                            responsible for your use or access of any internet pages, websites or platforms owned and/or
                            operated by our business partners, whether or not the link to such pages, websites or
                            platforms is provided on the Platform.
                        </p>
                        <p>
                            The Company may also use the information provided by you for internal analytical and
                            research purposes such as auditing, data analysis and research to improve our products,
                            services and customer communication.
                        </p>
                        <p>
                            Additionally, in the event of audit, reorganization, merger, sale, joint venture,
                            assignment, transfer or other disposition of all or any portion of our business, assets or
                            stock (including in connection with any bankruptcy or similar proceedings), we may
                            share/transfer/assign the Information we have collected to the relevant third party.
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">
                            What choices are available to you regarding collection, use and
                            distribution of your information?
                        </h6>
                        <p>To protect against the loss, misuse and alteration of the information under its control, the
                            Company has in place appropriate electronic and managerial procedures.
                        </p>
                        <p>
                            For example, the Company’s servers are accessible only by authorized personnel and your
                            information is shared with employees and authorised personnel on a need-to-know basis to
                            complete the transaction and to provide the services requested by you. Although the Company
                            will endeavour to safeguard the confidentiality of your Personal Information, transmissions
                            made by means of the internet cannot be made absolutely secure. By using the Platform, you
                            agree that the Company will have no liability for disclosure of your information due to
                            errors in transmission or unauthorized acts of third parties.
                        </p>
                        <p>
                            By browsing, accessing or purchasing from the Platform you agree to bind with the terms of
                            this Privacy Policy, consent to the collection, storage and use of your information provided
                            by you on the Platform. We shall not use the user’s information in any manner apart from the
                            terms mentioned in Terms & Conditions and this Privacy Policy published in the Platform.

                        </p>
                        <p>
                            You can at any time withdraw from the consent for collection and use of your Personal
                            Information but you may not be eligible to visit our Platform, or avail the services we
                            offer if you do so. It is also hereby clarified that your decision to withdraw your consent
                            will not affect the processing of Personal Information based on your previous consent.
                        </p>
                        <p>
                            You may be asked to provide information anytime you access or browse the Platform, not only
                            during the first time.
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">
                            What is the personal sensitive data or information that the
                            Company needs?
                        </h6>
                        <p>
                            Financial information such as bank account, credit card or debit card details and other
                            payment gateway details may be required for the payment processing for the services availed
                            by you on the Platform.
                        </p>
                        <p>
                            Any elaborate detail related to the Personal Information provided by you for us to provide
                            our service.
                        </p>
                        <p>
                            We may use the detail to create an account and give you access to your registered account on
                            the Platform.
                        </p>
                        <p>
                            We may try to monitor your physical, physiological and mental health condition based on the
                            clicks and visits you make in the Platform and make use of it for promotional purposes for
                            the services and/or products related to your search.
                        </p>
                        <p>
                            In case of any change in processing of the personal data of the user, the user shall be duly
                            notified at least 5 (five) days before the change in processing such personal data. The
                            notice shall be provided in English and shall be sent through email to the registered email
                            address of the user.
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">
                            How can you correct inaccuracies in the information?
                        </h6>
                        <p>
                            You may agree to provide accurate information which shall be true and up to date and have
                            access to update it anytime as per your wish. To correct or update any information you have
                            provided, the Platform allows you to do it online. In the event of loss of access details,
                            you can send an email to our Grievance Redressal Officer.
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">Secureness of information:</h6>
                        <p>
                            Although we make measures to protect your sensitive information, Personal Information that
                            is not open to the public, you understand and acknowledge that there is no such thing as
                            complete security, and we will not agree that there are no potential security breaches.
                            Beyond our control there are certain reasonable breaches like computer hacking, unauthorized
                            access to computer data, breaches of security and encryption etc.
                        </p>
                        <p>
                            We may keep your records of all communications both voice calls, digital messages and emails
                            received from you for the purpose of administrative services and may share that with third
                            parties when required by law or when required to facilitate the user with the services.
                        </p>
                        <p>
                            Your consent to our publishing of all testimonials and reviews given by you in relation to
                            the services received from our Platform. You agree that we may edit the testimonials or
                            reviews provided by you and republish the edited version in our Platform. If you have any
                            concern with the edited testimonial or reviews, you can contact through email to our
                            Grievance Redressal Officer.
                        </p>
                        <p>
                            We shall be entitled to retain your Information for our record for as long as needed or
                            permitted in light of the purpose(s) for which it was obtained and consistent with
                            applicable law and such Information shall be used by us only in consonance with this Privacy
                            Policy.
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">
                            Review of Information/Revocation of Consent by the User
                        </h6>
                        <p>
                            In the event where a user wishes to (i) review the Personal Information, Non-Personal
                            Information and sensitive personal information provided by them; (ii) delete and/or erase
                            any of such information provided by them; or (iii) revoke their consent provided to the
                            terms and conditions set out hereunder, the User may write to us at tapan.patel@petpooja.com
                            Upon receipt of the same, we will process the said request and undertake the necessary as
                            may be required to give effect to the User’s request.
                        </p>
                    </li>

                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">Cookies</h6>
                        <p>
                            The Company uses cookies to personalize your experience on the Platform and to display
                            advertisements or send you emails of offers of your interest (provided you have not opted
                            out of receiving such emails). Cookies are small pieces of information that are stored by
                            your browser on your device's hard drive. Cookies allow you to easily access our Platform,
                            by logging you in without having to type your login name each time.
                        </p>
                        <p>
                            By using this Platform, you agree that we can place cookies on your computer or device as
                            explained above. However, you can control and manage cookies in various ways. Removing or
                            blocking cookies can impact user experience and parts of this Platform may no longer be
                            fully accessible.
                        </p>
                        <p>
                            Most browsers will allow you to delete them on an individual basis or block cookies from
                            particular or all websites. In the event of you deleting all cookies, you will lose any and
                            all preferences you have set including your preference to opt-out from cookies.
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">Links to third party sites</h6>
                        <p>
                            The Platform may include links to third party applications/websites (“<strong>Third-Party
                                Sites</strong>”).
                            Such Third-Party Sites are governed by their respective privacy policies, which are beyond
                            our control. Once you leave our Platform, use of any information you provide is governed by
                            the privacy policy of the operator of the Third-Party Site you are visiting. That policy may
                            differ from ours. If you can't find the privacy policy of any of these Third-Party Sites,
                            you should contact the relevant Third Party Site directly for more information.
                        </p>
                        <p>
                            We do not provide any Personal Information or personally identifiable information to third
                            party websites/advertisers/ad-servers without your consent.
                        </p>

                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">Policy updates:</h6>
                        <p>
                            The Company reserves the right to change, amend, modify or update this Privacy Policy at any
                            time without any prior notice or information. Such changes shall be effective immediately
                            upon posting to the Platform. We encourage you to go through the Privacy Policy whenever you
                            visit the Platform to understand how we use the Information provided.
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">Grievance Redressal:</h6>
                        <p>
                            If there are any questions regarding this Privacy Policy, please write to our Grievance
                            Redressal Officer. If you are not satisfied with the response, please write to the Grievance
                            Officer, who is also the Nodal Officer of the Company.
                        </p>
                        <p>
                            Any complaints, or concerns with regards to content and or comment or breach of this Privacy
                            Policy shall be immediately informed to the designated Grievance Officer as mentioned below
                            via in writing or through email. The Grievance Officer shall acknowledge the complaint
                            within 72 (seventy-two) hours and redress the complaints within 15 (fifteen) days from the
                            date of receipt of complaint.
                        </p>
                        <a href="#"
                            class="text-decoration-underline">
                            Details of the Grievance Officer/Nodal Officer:
                        </a>
                        <p>
                            Name: Tapan Patel <br>
                            Designation: Vice-President – New Initiatives <br>
                            Email: tapan.patel@petpooja.com
                        </p>
                    </li>
                    <li class="mb-4">
                        <h6 class="fw-bold text-black mb-4">Jurisdiction:</h6>
                        <p>
                            Any kind of dispute arising out of the Platform and its users will be dealt in Ahmedabad and
                            shall be governed in accordance with Indian Law. Further, the courts of Ahmedabad shall have
                            exclusive jurisdiction to adjudicate the same.
                        </p>
                        <p>If for any reason, any part of the provision of this Privacy Policy is deemed invalid, the
                            remaining which is valid will be put to use.
                        </p>
                    </li>
                </ol>
                <p>Thank you for using the Platform!</p>
            </div>
        </pmd-card>
    </div>
</div>